const chevronIconHtml =
  '<svg class="nw-icon"><use xlink:href="#icon-chevron-right" /></svg>';

export default chevronIconHtml;
